import { FC } from "react";

interface PhoneProps {
  className?: string;
}

export const Phone: FC<PhoneProps> = ({ className }) => (
  <a href="tel:+48664970861" className={className}>
    664 970 861
  </a>
);
